import { render } from "./TaskDashboard.vue?vue&type=template&id=0f6d0b88&scoped=true"
import script from "./TaskDashboard.vue?vue&type=script&lang=js"
export * from "./TaskDashboard.vue?vue&type=script&lang=js"

import "./TaskDashboard.vue?vue&type=style&index=0&id=0f6d0b88&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6d0b88"]])

export default __exports__